import { createApi } from '@reduxjs/toolkit/query/react';
import baseApi from './base';

import paginationParams from 'utils/pagination-params';

export const list = 'LIST_QQ_PROFILES';
export const single = 'SINGLE_QQ_PROFILE';

export const qualificationQuestionProfilesApi = createApi({
  reducerPath: 'qualificationQuestionProfilesApi',
  baseQuery: baseApi,
  tagTypes: [list, single],
  endpoints: (builder) => ({
    createQualificationQuestionProfile: builder.mutation({
      query: (qualificationQuestionProfile) => ({
        url: '/qualification-question-profiles/create',
        method: 'POST',
        body: qualificationQuestionProfile
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data: created } = await queryFulfilled;
          dispatch(
            qualificationQuestionProfilesApi.util.updateQueryData('listQualificationQuestionProfiles', undefined, (draft) => {
              draft.data.items.unshift(created.data);
            })
          );
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    updateQualificationQuestionProfile: builder.mutation({
      query: ({ qualificationQuestionProfileId, ...attributes }) => ({
        url: `/qualification-question-profiles/update/${qualificationQuestionProfileId}`,
        method: 'PUT',
        body: { ...attributes }
      }),
      invalidatesTags: [single],
      async onQueryStarted({ qualificationQuestionProfileId }, { dispatch, queryFulfilled }) {
        try {
          const { data: updated } = await queryFulfilled;
          dispatch(
            qualificationQuestionProfilesApi.util.updateQueryData('listQualificationQuestionProfiles', undefined, (draft) => {
              const item = draft.data.items.find((profile) => profile.id === qualificationQuestionProfileId);
              if (item) {
                Object.assign(item, updated.data);
              }
            })
          );
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    deleteQualificationQuestionProfile: builder.mutation({
      query: (qualificationQuestionProfileId) => ({
        url: `/qualification-question-profiles/delete/${qualificationQuestionProfileId}`,
        method: 'DELETE'
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(
            qualificationQuestionProfilesApi.util.updateQueryData('listQualificationQuestionProfiles', undefined, (draft) => {
              const idx = draft.data.items.findIndex((item) => item.id === id);
              if (idx > -1) {
                draft.data.items.splice(idx, 1);
              }
            })
          );
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    getQualificationQuestionProfileById: builder.query({
      query: (qualificationQuestionProfileId) => `/qualification-question-profiles/get/${qualificationQuestionProfileId}`,
      providesTags: [single]
    }),
    listQualificationQuestionProfiles: builder.query({
      query: (params) => ({
        url: '/qualification-question-profiles/list',
        params
      }),
      providesTags: [list],
      ...paginationParams
    })
  })
});

export const {
  useCreateQualificationQuestionProfileMutation,
  useUpdateQualificationQuestionProfileMutation,
  useDeleteQualificationQuestionProfileMutation,
  useGetQualificationQuestionProfileByIdQuery,
  useListQualificationQuestionProfilesQuery
} = qualificationQuestionProfilesApi;
